<template>
  <div class="list-value">
    <span class="key">
        {{ title }}
    </span>
    <span class="value">
      <slot></slot>
    </span>
  </div>
</template>

<script>
export default {
  name: "CardListItem",
  props: {
    title: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped>

</style>
